/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'menu-user': {
    width: 12,
    height: 14,
    viewBox: '0 0 12 14',
    data: '<path pid="0" d="M11.414 10.931a5.844 5.844 0 00-1.26-1.867 5.87 5.87 0 00-1.867-1.26l-.018-.007a3.874 3.874 0 10-4.538.002l-.018.007c-.7.296-1.329.719-1.868 1.26a5.87 5.87 0 00-1.72 4.025.125.125 0 00.125.128h.938a.125.125 0 00.125-.122 4.658 4.658 0 011.371-3.192A4.657 4.657 0 016 8.53c1.253 0 2.43.488 3.316 1.374a4.658 4.658 0 011.371 3.192.124.124 0 00.126.122h.937c.07 0 .127-.058.125-.128a5.823 5.823 0 00-.46-2.16zM6 7.344a2.67 2.67 0 01-1.9-.788 2.67 2.67 0 01-.787-1.9c0-.717.28-1.392.787-1.9A2.67 2.67 0 016 1.97c.717 0 1.392.28 1.9.787a2.67 2.67 0 01.787 1.9 2.67 2.67 0 01-.787 1.9 2.67 2.67 0 01-1.9.788z" _fill="#595959" fill-rule="nonzero"/>'
  }
})
